import cn from "classnames";
import { useContext } from "react";
import {
  Checkmark as CheckmarkIcon,
  ExclamationMark as ExclamationMarkIcon,
} from "@rshbintech.dboul/icons";
import { FileItemContext } from "../../providers";
import styles from "./styles.module.scss";

export const StatusIcon = () => {
  const { hasError } = useContext(FileItemContext);

  return (
    <div
      className={cn(styles["status-icon"], styles.success, {
        [styles.error]: hasError,
      })}
    >
      {hasError ? (
        <ExclamationMarkIcon type="danger" />
      ) : (
        <CheckmarkIcon className={styles["checkmark-icon"]} />
      )}
    </div>
  );
};
